export default __webpack_public_path__ + "static/media/icon_general-download-file.83393d5b.svg";